export default __webpack_public_path__ + "static/media/img_sql_response-colorBkg.940bf0a4.png";